module.exports = __webpack_public_path__ + "static/media/ActivePure_Logo.56a296bf.png";